import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e51b714"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-info" }
const _hoisted_2 = { class: "columns is-multiline headline" }
const _hoisted_3 = { class: "horizontal-titles column is-half-tablet is-10-mobile" }
const _hoisted_4 = {
  key: 0,
  class: "title is-4"
}
const _hoisted_5 = {
  key: 1,
  class: "title is-4"
}
const _hoisted_6 = { class: "muted is-size-7 pt-0" }
const _hoisted_7 = { class: "column is-2-mobile is-hidden-tablet" }
const _hoisted_8 = {
  key: 0,
  class: "column is-half-tablet is-full-mobile is-flex is-flex-wrap-wrap is-end-justified-tablet"
}
const _hoisted_9 = {
  key: 1,
  class: "is-whole-flex is-end-justified-tablet mt-4"
}
const _hoisted_10 = {
  key: 0,
  class: "integration-option"
}
const _hoisted_11 = { class: "field" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "streamVisibility",
  class: "label"
}, "Visible on Stream List", -1))
const _hoisted_14 = {
  key: 0,
  class: "has-text-warning"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "subtitle is-6 is-inline" }, "Main Category Points: ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "subtitle is-6 is-inline" }, "Main Category Trophies: ", -1))
const _hoisted_18 = { class: "subtitle is-6 is-inline" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "muted" }, "pts", -1))
const _hoisted_20 = {
  key: 0,
  class: "trophy-container"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "trophy in-line rank-1" }, null, -1))
const _hoisted_22 = {
  key: 1,
  class: "trophy-container"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "trophy in-line rank-2" }, null, -1))
const _hoisted_24 = {
  key: 2,
  class: "trophy-container"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "trophy in-line rank-3" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "subtitle is-6 is-inline" }, "Extras: ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "muted" }, "pts", -1))
const _hoisted_28 = {
  key: 0,
  class: "trophy-container"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "trophy in-line rank-1" }, null, -1))
const _hoisted_30 = {
  key: 1,
  class: "trophy-container"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "trophy in-line rank-2" }, null, -1))
const _hoisted_32 = {
  key: 2,
  class: "trophy-container"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "trophy in-line rank-3" }, null, -1))
const _hoisted_34 = { key: 1 }
const _hoisted_35 = ["width"]
const _hoisted_36 = { class: "mb-1" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "58",
  y: "12",
  rx: "2",
  ry: "2",
  width: "78",
  height: "10"
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "30",
  cy: "16",
  r: "16"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_CountryDesignationSelector = _resolveComponent("CountryDesignationSelector")!
  const _component_ProfileActions = _resolveComponent("ProfileActions")!
  const _component_integration_profile = _resolveComponent("integration-profile")!
  const _component_ContentLoader = _resolveComponent("ContentLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.ownProfile)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.profileUsername ?? _ctx.$route.params.username) + " ", 1),
              (_ctx.profile && _ctx.profile.IsBanned)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("(Banned)")
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.profile?.CountryDesignation)
                ? (_openBlock(), _createBlock(_component_country_flag, {
                    key: 1,
                    country: _ctx.profile.CountryDesignation,
                    size: "normal",
                    title: _ctx.flagInfo
                  }, null, 8, ["country", "title"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.ownProfile)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_5, [
              _createTextVNode(" Your Profile "),
              _createVNode(_component_CountryDesignationSelector, { modelValue: _ctx.profile }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("strong", _hoisted_6, _toDisplayString(_ctx.registrationDate) + " (" + _toDisplayString(_ctx.getLastSeen()) + ")", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.ownProfile || _ctx.$store.state.devMode)
          ? (_openBlock(), _createBlock(_component_ProfileActions, {
              key: 0,
              ownProfile: _ctx.ownProfile,
              profile: _ctx.profile
            }, null, 8, ["ownProfile", "profile"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.profile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_integration_profile, {
              service: "Twitch",
              link: _ctx.linkTwitch,
              unlink: _ctx.unlinkTwitch,
              editable: _ctx.ownProfile,
              hasValue: !!_ctx.profile.TwitchInfo,
              avatarUrl: _ctx.profile.TwitchInfo?.Avatar,
              profileUrl: 'https://twitch.tv/' + _ctx.profile.TwitchInfo?.Username,
              profileName: _ctx.profile.TwitchInfo?.Username
            }, null, 8, ["link", "unlink", "editable", "hasValue", "avatarUrl", "profileUrl", "profileName"]),
            _createVNode(_component_integration_profile, {
              service: "YouTube",
              link: _ctx.linkYoutube,
              unlink: _ctx.unlinkYoutube,
              editable: _ctx.ownProfile,
              hasValue: !!_ctx.profile.Youtube,
              avatarUrl: _ctx.profile.Youtube?.Avatar,
              profileUrl: _ctx.profile.Youtube?.ChannelUrl,
              profileName: _ctx.profile.Youtube?.ChannelTitle
            }, null, 8, ["link", "unlink", "editable", "hasValue", "avatarUrl", "profileUrl", "profileName"]),
            _createVNode(_component_integration_profile, {
              service: "Discord",
              link: _ctx.linkDiscord,
              unlink: _ctx.unlinkDiscord,
              editable: _ctx.ownProfile,
              hasValue: !!_ctx.profile.DiscordInfo,
              avatarUrl: 'https://cdn.discordapp.com/avatars/' + _ctx.profile.DiscordInfo?.UserID + '/' + _ctx.profile.DiscordInfo?.Avatar,
              profileUrl: 'https://discordapp.com/users/' + _ctx.profile.DiscordInfo?.UserID,
              profileName: _ctx.profile.DiscordInfo?.Username + '#' + _ctx.profile.DiscordInfo?.Discriminator
            }, null, 8, ["link", "unlink", "editable", "hasValue", "avatarUrl", "profileUrl", "profileName"]),
            _createVNode(_component_integration_profile, {
              service: "Xbox",
              link: _ctx.linkXbox,
              unlink: _ctx.unlinkXbox,
              editable: _ctx.ownProfile,
              hasValue: !!_ctx.profile.XboxInfo,
              avatarUrl: _ctx.profile.XboxInfo?.Avatar,
              profileUrl: 'https://account.xbox.com/en-us/profile?gamertag='+_ctx.profile.XboxInfo?.Gamertag,
              profileName: _ctx.profile.XboxInfo?.Gamertag
            }, null, 8, ["link", "unlink", "editable", "hasValue", "avatarUrl", "profileUrl", "profileName"]),
            _createVNode(_component_integration_profile, {
              service: "Steam",
              link: _ctx.linkSteam,
              unlink: _ctx.unlinkSteam,
              editable: _ctx.ownProfile,
              hasValue: !!_ctx.profile.SteamInfo,
              avatarUrl: _ctx.profile.SteamInfo?.Avatar,
              profileUrl: _ctx.profile.SteamInfo?.ProfileUrl,
              profileName: _ctx.profile.SteamInfo?.PersonaName
            }, null, 8, ["link", "unlink", "editable", "hasValue", "avatarUrl", "profileUrl", "profileName"]),
            (_ctx.ownProfile || _ctx.$store.state.devMode)
              ? (_openBlock(), _createBlock(_component_ProfileActions, {
                  key: 0,
                  class: "is-hidden-mobile",
                  ownProfile: _ctx.ownProfile,
                  profile: _ctx.profile
                }, null, 8, ["ownProfile", "profile"]))
              : _createCommentVNode("", true),
            (_ctx.profile.TwitchInfo || _ctx.ownProfile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_ctx.profile.TwitchInfo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_ctx.ownProfile)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_11, [
                                _withDirectives(_createElementVNode("input", {
                                  id: "streamVisibility",
                                  type: "checkbox",
                                  name: "streamVisibility",
                                  class: "switch",
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.streamIsVisible) = $event)),
                                  disabled: _ctx.togglingStreamVisibility,
                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleStreamVisibility && _ctx.toggleStreamVisibility(...args)))
                                }, null, 8, _hoisted_12), [
                                  [_vModelCheckbox, _ctx.streamIsVisible]
                                ]),
                                _hoisted_13
                              ]),
                              (_ctx.profile.ValidationStreak < _ctx.validationStreakRequirement)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.validationStreakRequirement-_ctx.profile.ValidationStreak) + " more verified runs until eligible", 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.games && _ctx.career)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", null, [
            _hoisted_16,
            _createTextVNode(_toDisplayString(_ctx.mainPoints), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_17,
            _createTextVNode(_toDisplayString(_ctx.mainTrophies), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainCats, (cat) => {
            return (_openBlock(), _createElementBlock("div", { key: cat }, [
              (_ctx.career.RankInfoByCategory[cat])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("h6", _hoisted_18, _toDisplayString(cat) + ": ", 1),
                    _createTextVNode(_toDisplayString(_ctx.career.RankInfoByCategory[cat].Points), 1),
                    _hoisted_19,
                    _createTextVNode("   "),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.career.RankInfoByCategory[cat]], (info) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: info }, [
                        (info.GoldCount + info.SilverCount + info.BronzeCount)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (info.GoldCount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                    _hoisted_21,
                                    _createTextVNode(" × " + _toDisplayString(info.GoldCount), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (info.SilverCount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                    _hoisted_23,
                                    _createTextVNode(" × " + _toDisplayString(info.SilverCount), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (info.BronzeCount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                    _hoisted_25,
                                    _createTextVNode(" × " + _toDisplayString(info.BronzeCount), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _hoisted_26,
          _createTextVNode(_toDisplayString(_ctx.extraPoints), 1),
          _hoisted_27,
          _createTextVNode("   "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.extraTrophies], (info) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: info }, [
              (info.GoldCount + info.SilverCount + info.BronzeCount)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (info.GoldCount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                          _hoisted_29,
                          _createTextVNode(" × " + _toDisplayString(info.GoldCount), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (info.SilverCount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                          _hoisted_31,
                          _createTextVNode(" × " + _toDisplayString(info.SilverCount), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (info.BronzeCount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                          _hoisted_33,
                          _createTextVNode(" × " + _toDisplayString(info.BronzeCount), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_34, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
            return _createElementVNode("div", { key: i }, [
              _createElementVNode("div", null, [
                _createVNode(_component_ContentLoader, {
                  width: "120",
                  height: "20",
                  "primary-color": "#1f2a3c",
                  "secondary-color": "#2c3b55"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("rect", {
                      x: "0",
                      y: "5",
                      rx: "2",
                      ry: "2",
                      width: (100 + Math.random() * 20),
                      height: "16"
                    }, null, 8, _hoisted_35)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("p", _hoisted_36, [
                _createVNode(_component_ContentLoader, {
                  width: "140",
                  height: "40",
                  "primary-color": "#1f2a3c",
                  "secondary-color": "#2c3b55"
                }, {
                  default: _withCtx(() => [
                    _hoisted_37,
                    _hoisted_38
                  ]),
                  _: 1
                })
              ])
            ])
          }), 64))
        ]))
  ]))
}